import { MaintenanceForwardingEstablishmentChoiceEntryProposalData } from "../../../../../../features/forwardings/types/maintenanceForwarding.type";
import EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse from "./AwaitingEstablishmentReponse";
import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";

interface EstablishmentChoiceEntryProposalProps {
  proposal: MaintenanceForwardingEstablishmentChoiceEntryProposalData;
}

const EstablishmentChoiceEntryProposal = ({ proposal }: EstablishmentChoiceEntryProposalProps) => {
  if (proposal.status === 'awaiting_establishment_response') {
    return <EstablishmentChoiceEntryProposalAwaitingEstablishmentResponse />
  }

  return (
    <Box className="p-4 flex flex-col gap-3">
      <div>
        <p className="font-semibold">
          {proposal.id.split('-')[0]?.toUpperCase()}
        </p>
      </div>

      <div className="flex gap-3">
        {proposal?.process_started_at && (
          <ResumeItem
            label="Data do lance"
            value={formatDateTime(new Date(proposal?.process_started_at))}
            className="text-xs"
            valueClassName="font-bold text-sm"
          />
        )}
      </div>
    </Box>
  );
}

export default EstablishmentChoiceEntryProposal;
